import ParticlesBg from "particles-bg";

export const Header = (props) => {
  return (
    <header id='header'>
      <div className='intro'>
        <ParticlesBg type="cobweb" color="E55F36" bg={{zIndex: 0, position:"absolute", top:0}} />
        <div className='overlay'>
          <div className='container'>

            <div className='row'>
              <div className='col-md-12 intro-text'>
                <h1>
                  {props.data ? props.data.title : 'Loading'}
                  <span>{props.data ? props.data.lideres : 'Loading'}</span>
                  {props.data ? props.data.title2 : 'Loading'}
                  <span></span>
                </h1>
                <p>{props.data ? props.data.paragraph : 'Loading'}<br/>
                {props.data ? props.data.paragraph2 : 'Loading'}</p>
                <a
                  href='#features'
                  className='btn btn-custom btn-lg page-scroll'
                >
                  Saiba mais
                </a>{' '}
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  )
}
